﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClientConfiguration_1 = require("../../OperationalContextClientConfiguration");
class BaseClient {
    getBaseUrl(unknown, baseUrl) {
        return baseUrl || OperationalContextClientConfiguration_1.OperationalContextClientConfiguration.getBaseUrl();
    }
    transformOptions(options) {
        let token = OperationalContextClientConfiguration_1.OperationalContextClientConfiguration.getToken();
        if (token) {
            let newHeaders = new Headers(options.headers);
            newHeaders.append('Authorization', `Bearer ${token}`);
            options.headers = newHeaders;
        }
        return Promise.resolve(options);
    }
}
exports.BaseClient = BaseClient;
//# sourceMappingURL=BaseClient.js.map